var $doc = $(document),
  $window = $(window);

/* ----------------------------------*\
||  Binder (@TODO test this part)                      ||
\*---------------------------------- */

$doc.ready(function(jQuery) {
  $doc.on("click", ".drop-over .binder:not(.new-binder)", function(e) {
    e.preventDefault();
    var id = $(".post").attr("data-id"),
      that = $(this),
      binder = that.attr("data-binder");

    if (that.hasClass("in-binder")) {
      $.when(removeFromBinder(id, binder)).done(function(
        response,
        textStatus,
        jqXHR
      ) {
        // Update only if there is no duplicate
        // console.log(response);

        if (response.success) {
          var isFav = response.data.fav,
            star = $(".article-top-bar .icon-star-full"),
            dropOver = $('[data-dropover="favorite-dropover"]');
          that.removeClass("in-binder");
          if (!isFav) {
            star.removeClass("is-favorited");
            DropOver(dropOver);
          }
        }
      });
    } else {
      $.when(addToBinder(id, binder)).done(function(
        response,
        textStatus,
        jqXHR
      ) {
        // Update only if there is no duplicate
        if (response.success) {
          var star = $(".article-top-bar .icon-star-full"),
            binder_id = response.data.binder_id,
            binder = $("#" + binder_id);

          binder.addClass("in-binder");
          star.addClass("is-favorited");

          DropOver(star);
        }
      });
    }
  });
});
